import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DropdownItem } from 'reactstrap';
import { history } from 'store';
import SweetAlert from 'react-bootstrap-sweetalert';
import IntlMessages from 'util/IntlMessages';
import ListRowImage from 'components/listRowImage';
import ListRowFavourite from 'components/ListRowFavourite';
import ListRowCheckbox from 'components/ListRowCheckbox';
import ListRowData from 'components/ListRowData';
import ListRowDropdown from 'components/ListRowDropdown';
import PortfolioEdit from '../../portfolioMaintenance/portfolioEdit/index';
import {
    addFavouritePortfolio,
    onPortfolioSelect,
    onDeletePortfolio,
    onEditPortfolio,
    onPortfolioDashboard,
    showPortfolioLoader,
} from 'actions/portfolio';
import { setStorageItem, SELECTED_PORTFOLIO } from 'services/Authentication';

const PortfolioRow = (props) => {
    const dispatch = useDispatch();
    const [menuState, setMenuState] = useState(false);
    const [portfolio, setPortfolio] = useState(props.portfolio);
    const [deletePortfolioCheck, setDeletePortfolioCheck] = useState(false);
    const width = useSelector(state => state.settings.width);
    // const { portfolio } = props;

    useEffect(() => {
        setPortfolio(props.portfolio);
    }, [props]);

    const { name, description, starred } = portfolio;
    const options = [
        'Edit',
        'Delete',
        'Dashboard',
    ];

    const portfolioOptionToggle = () => {
        setMenuState(!menuState);
    };

    const deletePortfolio = (portfolio) => {
        dispatch(onDeletePortfolio(portfolio?.id));
    };

    const editPortfolio = () => {
        setMenuState(false);
        dispatch(onEditPortfolio(portfolio));
    };

    const portfolioDashboard = (portfolio) => {
        setStorageItem(SELECTED_PORTFOLIO, portfolio?.id);
        // dispatch(showPortfolioLoader());
        // dispatch(onPortfolioDashboard(portfolio?.id));
        history.push('/app/portfolio-dashboard/default');
    };

    return (
        <div className="contact-item">
            <ListRowCheckbox selected={portfolio.selected} onClick={() => dispatch(onPortfolioSelect(portfolio))} />
            <ListRowFavourite width={width} onClick={() => dispatch(addFavouritePortfolio(portfolio))} starred={starred} />
            <ListRowImage width={width} data={portfolio} />
            <ListRowData lineOne={name} lineTwoLeft={description}/>
            <ListRowDropdown
                menuState={menuState}
                toggle={portfolioOptionToggle}
                options={options}
                dropdownItems={options.map(option =>
                    <DropdownItem key={option} onClick={() => {
                        if (option === 'Edit') {
                            editPortfolio();
                        } else if (option === 'Delete') {
                            setDeletePortfolioCheck(true);
                        } else if (option === 'Dashboard') {
                            portfolioDashboard(portfolio);
                        }
                    }
                    }>
                        {option}
                    </DropdownItem>,
                )}
            />
            <div>
                <PortfolioEdit />
            </div>
            <SweetAlert show={deletePortfolioCheck}
                warning
                showCancel
                confirmBtnText={<IntlMessages id="button.yesDeleteIt" />}
                cancelBtnText={<IntlMessages id="button.cancel" />}
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title={<span style={{ fontWeight: 'bold', color: 'grey', fontSize: '200%' }}><IntlMessages id="general.areYouSure" /></span>}
                onConfirm={() => {
                    deletePortfolio(portfolio);
                    setDeletePortfolioCheck(false);
                }}
                onCancel={() => {
                    setDeletePortfolioCheck(false);
                }}
            >
                <IntlMessages id="portfolio.deletePortfolio" />
            </SweetAlert>
        </div>
    );
};

export default PortfolioRow;


// WEBPACK FOOTER //
// ./components/Agile/portfolio/portfolioList/portfolioRow/index.js